import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-logged-in-header',
  templateUrl: './logged-in-header.component.html',
  styleUrls: ['./logged-in-header.component.scss']
})
export class LoggedInHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  //*************************************************Added all value for declaration***********************************************/
  onToggleLanguage() {

  }
  signOutText: any;
  loggedInUser: any;
 
  languages = [

  ];


  showSignIn = false;
  showProfileIcon = true;

 
  signInText = 'Sign In';

  totalCartItem$: Observable<number> = of(0);
  setLanguage(id: string) {
    console.log('Language changed to:', id);
  }

  onToggleSignIn() {
    this.showSignIn = !this.showSignIn;
  }

  onToggleProfile() {
    console.log('Profile toggled');
  }

  gotoCart(path: string) {
    console.log('Navigating to:', path);
  }
  changeCustomerDialog = false;

  userLoggedInSuccess = false;
  userLoggedOutSuccess = false;
  userLoggedInFail = false;

  openedForgotPassword = false;
  openedForgotPasswordConfirmation = false;

  showProfile = false;
  openedProfile = false;

  defaultPassword = { opened: false };
  openedPassword = false;

  termsConditionAgreement = { opened: false };

  closeChangeCustomerDialog() {
    this.changeCustomerDialog = false;
  }

  closeProfileDialog() {
    this.openedProfile = false;
  }

  closeDefaultPasswordDialog() {
    this.defaultPassword.opened = false;
  }

  closeTermsConditionDialog() {
    this.termsConditionAgreement.opened = false;
  }

  close(action: string) {
    console.log('Dialog closed:', action);
  }

  //*************************************************Added all value for declaration***********************************************/

}
